import * as TherapistApis from '../apis/therapist';
import * as CustomApis from '../apis/custom';
import * as UserApis from '../apis/user';
import * as ActionTypes from '../constants/actions';
import * as AuthUtils from '../utils/auth';
import _ from 'lodash';

const TWILIO_TOKEN = ( process.env.REACT_APP_DEPLOYMENT_ENV === 'production' ) ? 'bearer vOTUaup5Y0yMUa3FfcBcsTIrBnAov1LeSL4pCL3UOuEooxoJ' : 
					'bearer RKFBxn1uMfvShMg1m5Pyo03ZOZrHX3wLo0pPTrjHBXYMp2gj';

export function getUserDetails(callback) {
	return async (dispatch) => {
		const response = await UserApis.getUserDetails();
		dispatch(setUserData(response.data));
		if (callback) {
			return callback();
		}
	};
}

export function getUserStatus(data, callback) {
	return async (dispatch) => {
		const response = await TherapistApis.getUserStatus(data);
		if(response.data && response.data.status){
			dispatch(setUserStatus(response.data.status));
			if (callback) {
				return callback();
			}
		}
	};
}

export function changeUserStatus(data, therapistRoom,callback) {
	return async (dispatch) => {
		const response = await TherapistApis.changeUserStatus(data);
			dispatch(getUserStatus({roomId: therapistRoom}));
			if (callback) {
				return callback();
			}
	};
}

export function getCurrentUserConfirmation(data, callback) {
	return async (dispatch) => {
		const response = await UserApis.getCurrentUserConfirmation(data);
		dispatch(setUserConfirmation(response.message.toLowerCase() === "success"));
		if (callback) {
			return callback();
		}
	};
}

export function getUserRole(callback) {
	return async (dispatch) => {
		const response = await UserApis.getUserRole();
		dispatch(setUserRole(response.data));
		// ACLUtils.saveRoleCookie(JSON.stringify(response.data.roles));
		if (callback) {
			return callback();
		}
	};
}


export function getActiveCallDetails(data, callback) {
	return async (dispatch) => {
		const response = await TherapistApis.getActiveCallDetails(data);
		let activeCall = response.data;
		dispatch(setActiveCallDetails(activeCall[0]));
		if (callback) {
			return callback();
		}
	};
}

export function getCurrentActiveCallDetails(data, callback) {
	return async (dispatch) => {
		const response = await TherapistApis.getActiveCallDetails(data);
		let activeCall = response.data;
		if(activeCall && activeCall[0])
			dispatch(setCurrentActiveCall(activeCall[0]));
		if (callback) {
			return callback();
		}
	};
}

export function getCallHistory(data, callback) {
	return async (dispatch) => {
		const response = await TherapistApis.getCallHistory(data);
		let activeCall = response.data;
		dispatch(setCallHistory(activeCall));
		if (callback) {
			return callback();
		}
	};
}

export function getActiveCallHistory(data, callback) {
	return async (dispatch) => {
		const response = await TherapistApis.getActiveCallHistory(data);

		if(response.status === "403"){
			AuthUtils.removeAuthCookie();
			window.location.reload();
		} else {
			let activeCall = response.data;
			dispatch(setActiveCallHistory(activeCall));
			if (callback) {
				return callback();
			}
		}
	};
}

export function changeCallStatus(data, callback) {
	return async (dispatch) => {
		const response = await TherapistApis.changeCallStatus(data);
		dispatch(getActiveCallHistory());
		if (callback) {
			return callback();
		}
	};
}

export function changeCallField(data, callback) {
	return async (dispatch) => {
		
		const response = await TherapistApis.changeCallField(data);
		dispatch(getActiveCallHistory());
		if (callback) {
			return callback();
		}
	};
}

export function changeCallFieldMute(data, callback) {
	return async (dispatch) => {
		
		const response = await TherapistApis.changeCallField(data);
		window.localStorage.setItem('unmute', "true")
		// dispatch(getActiveCallHistory());
		// if (callback) {
		// 	return callback();
		// }
	};
}

export function getGroupCallHistory(data, callback) {
	return async (dispatch) => {
		dispatch(fetchGroupCallHistory());
		const response = await TherapistApis.getGroupCallHistory(data);
		dispatch(setGroupCallHistory(response.data));
		if (callback) {
			return callback();
		}
	};
}

export function updateCallTimeStatus(data, callback) {
	return async (dispatch) => {
		await TherapistApis.updateCallTimeStatus(data);
		if (callback) {
			return callback();
		}
	};
}

export function getPatientVisits( callback) {
	return async (dispatch) => {
		const response = await TherapistApis.getPatientsVisitData();
		if(response.status === "200" && response.data && response.data.visitDetails){
			dispatch(setPatientVisit(response.data.visitDetails));
			if (callback) {
				return callback();
			}
		}
	};
}

export function sendTextMessage(data, callback) {
	return async (dispatch) => {
		const headers = {
			Authorization : TWILIO_TOKEN
		}
		const response = await CustomApis.sendTextMessage(data, headers);
		if (callback) {
			return callback();
		}
	};
}


export function setUserData(currentUser) {
	return {
		type : ActionTypes.USER.SET_USER_DATA,
        currentUser
	};
}

export function setUserConfirmation(currentUserConfirmation) {
	return {
		type : ActionTypes.USER.SET_USER_CONFIRMATION,
        currentUserConfirmation
	};
}

export function setUserRole(currentUserRole) {
	return {
		type : ActionTypes.USER.SET_USER_ROLE,
        currentUserRole
	};
}

export function unsetUserData() {
	// ACLUtils.removeCookie();
	return {
		type : ActionTypes.USER.UNSET_USER_DATA,
	};
}

export function unsetUserRole() {
	// ACLUtils.removeCookie();
	return {
		type : ActionTypes.USER.UNSET_USER_ROLE,
	};
}

export function setUserStatus(currentUserStatus) {
	return {
		type : ActionTypes.USER.SET_USER_STATUS,
        currentUserStatus
	};
}

export function unsetUserStatus() {
	// ACLUtils.removeCookie();
	return {
		type : ActionTypes.USER.UNSET_USER_STATUS,
	};
}

export function setCurrentActiveCall(currentActiveCall) {
	return {
		type : ActionTypes.THERAPISTS.SET_CURRENT_ACTIVE_CALL,
        currentActiveCall
	};
}

export function unsetCurrentActiveCall() {
	return {
		type : ActionTypes.THERAPISTS.UNSET_CURRENT_ACTIVE_CALL
	};
}

export function setActiveCallHistory(activeCallHistory) {
	return {
		type : ActionTypes.THERAPISTS.SET_ACTIVE_CALL_HISTORY,
        activeCallHistory
	};
}

export function unsetActiveCallHistory() {
	return {
		type : ActionTypes.THERAPISTS.UNSET_ACTIVE_CALL_HISTORY
	};
}

export function unsetActiveCallHistoryFlag() {
	return {
		type : ActionTypes.THERAPISTS.UNSET_ACTIVE_CALL_HISTORY_FLAG
	};
}

export function setCallHistory(callHistory) {
	return {
		type : ActionTypes.THERAPISTS.SET_CALL_HISTORY,
        callHistory
	};
}

export function unsetCallHistory() {
	return {
		type : ActionTypes.THERAPISTS.UNSET_CALL_HISTORY
	};
}

export function setGroupCallHistory(groupCallHistory) {
	return {
		type : ActionTypes.THERAPISTS.SET_GROUP_CALL_HISTORY,
        groupCallHistory
	};
}

export function fetchGroupCallHistory() {
	return {
		type : ActionTypes.THERAPISTS.FETCH_GROUP_CALL_HISTORY
	};
}

export function unsetGroupCallHistory() {
	return {
		type : ActionTypes.THERAPISTS.UNSET_GROUP_CALL_HISTORY
	};
}

export function setActiveCallDetails(activeCall) {
	return {
		type : ActionTypes.THERAPISTS.SET_ACTIVE_CALL_DATA,
        activeCall
	};
}

export function unsetActiveCallDetails() {
	return {
		type : ActionTypes.THERAPISTS.UNSET_ACTIVE_CALL_DATA
	};
}


export function setPatientVisit(todayVisits) {
	return {
		type : ActionTypes.THERAPISTS.SET_PATIENT_VISITS,
        todayVisits
	};
}

export function unsetPatientVisit() {
	return {
		type : ActionTypes.THERAPISTS.UNSET_PATIENT_VISITS
	};
}
